import { useQuery, useQueryClient } from "@tanstack/react-query";
import { axiosGet } from "@/services/axiosService";
import useStore from "@/pages/omni-builder/store";

export default function useInstagramConfig() {
  const queryClient = useQueryClient();
  const setIsInstagramLoading = useStore(
    (state) => state.setIsInstagramLoading,
  );

  return useQuery({
    queryKey: ["configurations", "instagram"],
    queryFn: async () => {
      const cachedData: any =
        queryClient.getQueryData(["configurations", "instagram"]) ?? null;

      if (!cachedData) {
        setIsInstagramLoading(true);
      }

      const response = await axiosGet(
        "/configurations/getAppConfig?siteName=instagram",
      );

      let result: any = null;
      if (response.data && response.data.length > 0) {
        result = response.data.map((account: any) => ({
          _id: account._id,
          accountName: account.accountName,
          username: account.username,
          picture: account.picture,
          account_type: account.account_type,
          followers_count: account.followers_count,
          follows_count: account.follows_count,
          biography: account.biography,
          connected: account.connected,
          botId: account.botId,
          botCustomId: account.botCustomId,
          showPrompt: false, // default value
        }));
      }

      // result contains array of Instagram accounts with their details
      setIsInstagramLoading(false);
      return result;
    },
    staleTime: Infinity,
  });
}
